var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-page"},[_c('ivuTable',{attrs:{"border":"","columns":_vm.table.columns,"data":_vm.data.plan_detail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }